import {configureRootTheme} from '@yandex-lego/components/Theme';
import {theme} from '@yandex-lego/components/Theme/presets/default';
import ErrorReporter from 'components/ErrorReporter';
import FrameSelector from 'components/FrameSelector';
import framesConfig from 'modules/frames';
import React from 'react';

import ReactDOM from 'react-dom';
import 'styles/s0-normalize.scss';
import 'styles/s1-fonts.scss';
import 'styles/s2-global.scss';
import {isProd} from 'utils/env';

window.addEventListener('load', () => {
  configureRootTheme({theme, root: document.getElementById('research-app')});

  ReactDOM.render(
    <ErrorReporter handleGlobal showTraceback={!isProd}>
      <FrameSelector config={framesConfig} defaultFrame="ResearchApp" />
    </ErrorReporter>,
    document.getElementById('research-app'),
  );
});
